// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_SEO_BABY = "Baz\u00e1r";
export const REVIEWS_OF_THE_SELLER_username = "Hodnotenie pred\u00e1vaj\u00facej %(username)s";
